<template>
    <div>
        <v-card raised>
            <v-card-title>
                Permit Rates
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
            </v-card-title>
            <v-card-text>
                <v-data-table :loading="loadingPermitRates" :headers="headers" :items="permitRates" :search="search" class="elevation-1">

                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                search: '',
                appURL: process.env.MIX_APP_URL,
                loadingPermitRates: false,
                permitRates: [],
                headers: [
                    { text: 'Permit Type Code', align: 'left', sortable: true, value: 'permit_type_code',},
                    { text: 'Description', value: 'description' },
                    { text: 'Effective Date', value: 'effective_date' },
                    { text: 'Expiration Date', value: 'expiration_date' },
                ],


            }
        },
        created() {
            this.fetchPermitRates();
        },
        watch: {
            dialog (val) {
                val || this.close()
            },
        },
        methods: {
            fetchPermitRates: function () {
                this.loadingPermitRates = true;
                axios.get(this.appURL + '/api/permitrates')
                    .then((response) => {
                        if(response.status === 200)
                        {
                            this.permitRates = response.data;
                        }
                        this.loadingPermitRates = false;
                    })
                    .catch(error => {
                        console.log(error);
                        this.loadingPermitRates = false;
                    });
            },
        }
    }
</script>
